/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./profile.defs.js";
export { main as default } from "./profile.defs.js";
